/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';

import "./video-window.css";

const VideoWindow = ({ vidLink, sourceName, sourceLink }) => {

    const renderLinkToSource = (sourceName, sourceLink) => {
        if (!sourceName || !sourceLink) {
            return;
        }

        return (<a className="window-source" href={sourceLink} target = "_blank" rel="noreferrer">Source: { sourceName }</a>)
    };

    return (
        <>
        <div className="window-wrapper">
            <div className="window">
                <div className="window-options">
                    <span className="circle red"></span>
                    <span className="circle yellow"></span> 
                    <span className="circle green"></span> 
                </div>
                <iframe width="560" height="315" src={vidLink} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                {renderLinkToSource(sourceName, sourceLink)}
            </div>
        </div>
        </>
    );
}

export default VideoWindow;